import React, { useState, useEffect, useContext, Fragment, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import {toast} from "react-toastify";
import { data } from 'jquery';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import ConstantInput from "../../../../components/sales/Input/constantInput/constantInput";
import DropDownInput from "../../../../components/sales/Input/dropDownInput/dropDownInput";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import Camera from 'react-html5-camera-photo';
import FileUpload from "../../../../components/sales/fileUpload/fileUpload";
import CheckboxFir from "components/sales/Input/checkbox/checkboxFir";
import useLatLng from "hooks/uselatlng/uselatlng";
import ModalPop from 'components/sales/modal/modal';
import DatePicker from "components/sales/datePicker/datePicker";
import moment from 'moment';
import "./ncs.css";

const NcsMeetingComplete = ({
    getNcsMeetingbyId,
    ncsMeetingsData,
    history,
    match,
    documentUrlDataPublic,
    documentUploadUrlPublic,
    saveAndCheckoutNCSMeeting,
    saveAndCheckInNCSMeeting
}) => {

  // const handleTakePhoto = useCallback((dataUri) => {
  //   setIsLoading(true);
  //   setSelfieCheckin(dataUri);
  //   setRetakeOne(false);
  //   setIsLoading(false);
  // }, []); 

  // const memoizedCamera = useMemo(() => {
  //   return (
  //     <Camera
  //       idealFacingMode={'user'}
  //       idealResolution={{ width: 300, height: 250 }}
  //       onTakePhoto={handleTakePhoto} 
  //     />
  //   );
  // }, [handleTakePhoto]);

  // Above commenmted code is write to fix camera flikring issue

  const inputs = {
    account_name:'',
    account_address:'',
    last_activity_date:'',
    no_of_gates:'',
    boom_barrier_present:'',
    site_status:'',
    competitor_name:'',
    competitor_solution:'',
    attachments:[{url:'',show:true,retake: false}],
    checkout_selfie:'',
    exisiting_problem_faced:'',
    checkout_remark:'',
    not_allowed_to_take_information:false
  }
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [ncsData, setNcsData] = useState(null);
  const [inputList, setInputList] = useState(inputs);
  const [selfie, setSelfie] = useState('');
  const [selfieUrl, setSelfieUrl] = useState("");
  const [retake, setRetake] = useState(true);
  const [addItem, setAddItem] = useState(1);
  const islatlng = useLatLng();
  const [isAllow, setIsAllow] = useState(false);
  const [latVal, setLatVal] = useState("");
  const [lngVal, setLngVal] = useState("");
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [isCheckIn, setIsCheckIn] = useState(false);
  const [checkinRemark, setCheckinRemark] = useState(null);
  const [checkinSelfie, setCheckinSelfie] = useState(null);
  const [selfieCheckin, setSelfieCheckin] = useState('');
  const [retakeOne, setRetakeOne] = useState(true);
  const [selfieUrlCheckIn, setSelfieUrlCheckIn] = useState("");
  const [isCheckInStatus, setIsCheckInStatus] = useState(false);
  const [isElementRequired, setIsElementRequired] = useState(true);

  useEffect(() => {
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if (!isNaN(lati) && !isNaN(langi)) {
        var lat =  Number(islatlng?.lat);
        var lng = Number(islatlng?.lng);
        setLatVal(lat);
        setLngVal(lng);
    }
  }, [islatlng]);

  useEffect(() => {
    if (getNcsMeetingbyId !== null){
        (async () => {
            setIsLoading(true);
            const res = await getNcsMeetingbyId(match.params.id,"Open");
            if(res) {
              console.log(res);
              if(res[0].client_name != undefined && res[0].client_name != '' && res[0].address_1 !='' && res[0].address_1 != undefined) {
                  const list = {...inputList};
                  list['account_name'] = res[0].client_name;
                  list['account_address'] = res[0].address_1;
                  if(res[0].activity_date != undefined && res[0].activity_date != null) {
                    console.log('ghgh ', moment(res[0].activity_date).format('DD-MM-YYYY'));
                    list['last_activity_date'] = moment(res[0].activity_date).format('DD-MM-YYYY');
                  }
                  setTimeout(
                    setInputList(list),
                    1000
                  );

                  if(res[0]?.checkin_status) {
                    setIsCheckInStatus(res[0].checkin_status);
                  }    
              }
            }
            setIsLoading(false);
          })();
    }
      
  }, [getNcsMeetingbyId]); 

  useEffect(() => {
    if (selfie !== '') {
      (async () => {
          setIsLoading(true)
          const url = await documentUploadUrlPublic({base_64_file: selfie});
          console.log('ccc ', selfieUrl);
          setSelfieUrl(url.file_url);
          const list = {...inputList};
          list['checkout_selfie'] = url.file_url;
          setInputList(list);
          setIsLoading(false);
      })()
    }
}, [selfie]);

useEffect(() => {
  if (selfie !== '') {
    (async () => {
        setIsLoading(true)
        const url = await documentUploadUrlPublic({base_64_file: selfie});
        console.log('ccc ', selfieUrl);
        setSelfieUrl(url.file_url);
        const list = {...inputList};
        list['checkout_selfie'] = url.file_url;
        setInputList(list);
        setIsLoading(false);
    })()
  }
}, [selfie]);

useEffect(() => {
    if (selfieCheckin !== '') {
      (async () => {
          setIsLoading(true)
          const url = await documentUploadUrlPublic({base_64_file: selfieCheckin});
          setSelfieUrlCheckIn(url.file_url);
          setIsLoading(false);
      })()
    }
}, [selfieCheckin]);

const handleAddClick = () => {
  var isEmpty = false;
  inputList.attachments.map((val,key) => {
     if(val.url == "") {
      isEmpty = true;
      return false;
     }
  });
  if(isEmpty) {
    toast.warning('Please add photo for first input');
    return false;
  }
  const list = {...inputList};
  list['attachments'].push({url:'',show:true});
  setInputList(list);
};

const handleRemoveClick = (index) => {
  const list = {...inputList};
  list['attachments'].splice(index, 1);
  setInputList(list);
};

useEffect(() => {
  if (ncsMeetingsData && ncsMeetingsData && ncsMeetingsData?.length > 0) {
    setNcsData(ncsMeetingsData[0]); 
  }
}, [ncsMeetingsData]);

const removeAttachmentDoc = (val,index) => {
      const list = {...inputList};
      list['attachments'][index]['url'] = val;
      list['attachments'][index]['show'] = true;
      list['attachments'][index]['retake'] = false;
      setInputList(list);
}

const saveAttachmentDoc = (val,index) => {
  if(val != "") {
    (async () => {
        setIsLoading(true)
        const url = await documentUploadUrlPublic({base_64_file: val});
        console.log('uploaded Image >>  ', url);
        const list = {...inputList};
        list['attachments'][index]['url'] = url.file_url;
        list['attachments'][index]['show'] = false;
        list['attachments'][index]['retake'] = true;
        setInputList(list);
    })();
   }
};

const handleInput2Value = (val) => {
  const list = {...inputList};
  if(val) {
    list['last_activity_date']='';
    list['no_of_gates']='';
    list['boom_barrier_present']='';
    list['site_status']='';
    list['competitor_name']='';
    list['competitor_solution']='';
    list['attachments']=[{url:''}];
    list['last_activity_date']='';
    list['exisiting_problem_faced']='';
  }
  list['not_allowed_to_take_information'] = val;
  setInputList(list);
};

const handleCheckOut = () => {
  if(match?.params?.id == '' || 
    match?.params?.id == undefined || 
    match?.params?.id == null || 
    latVal == "" ||
    lngVal == "" || 
    inputList?.checkout_selfie == "" || 
    inputList?.checkout_remark == "") {
    toast.error('Checkout details are missing.');
    return false;
  }
  if(!inputList.not_allowed_to_take_information) {
    if(inputList.account_name == '' ||
      inputList.account_address == '' ||
      inputList.last_activity_date == '' ||
      inputList.no_of_gates == '' ||
      inputList.boom_barrier_present == '' ||
      inputList.site_status == '') {
      toast.error('Meeting details are missing.');
      return false;
    }
  }
  if(isElementRequired && (inputList.competitor_name == '' || inputList.competitor_solution == '' || inputList.exisiting_problem_faced == '')) {
      toast.error('Meeting details are missing.');
      return false;
  }

  const payload = {
    ncs_meeting_id:match?.params?.id,
    latitude:latVal,
    longitude:lngVal,
    meeting_data:inputList
  }
  console.log('final data', payload);
  (async () => {
    setIsLoading(true);
    const res = await saveAndCheckoutNCSMeeting(payload);
    if (res.status) {
      // console.log(res);
      setIsSuccessModal(true);
      setIsLoading(false);
    } else {
      toast.error(res.message ?? 'Issue with checkout meeting');
      setIsLoading(false);
    }
  })();
  setIsLoading(true);
}

const handleCheckIn = () => {
   setIsCheckIn(true);
}

const hideCheckIn = () => {
  setIsCheckIn(false);
}

const handleSubmitCheckIn = () => {
  if(selfieUrlCheckIn == '' || checkinRemark == '') {
      toast.error('All checkin details are required.');
      return false;
  }
  if(match?.params?.id == '' || match?.params?.id == undefined || match?.params?.id == null || latVal == "" || lngVal == "") {
    toast.error('Meeting details are missing to checkin.');
    return false;
  }
  const payload = {
    ncs_meeting_id:match?.params?.id,
    latitude:latVal,
    longitude:lngVal,
    check_in_selfie:selfieUrlCheckIn,
    check_in_remark:checkinRemark
  };
  (async () => {
    setIsLoading(true);
    const res = await saveAndCheckInNCSMeeting(payload);
    if (res.status) {
      // console.log(res);
      window.location.reload();
      setIsLoading(false);
    } else {
      toast.error(res.message ?? 'Issue with checkout meeting');
      setIsLoading(false);
    }
  })();
  setIsLoading(true);
}

const headerBtns = () => {
  return (
    <Fragment>
      {isCheckInStatus ?
         <Button onClick={handleCheckOut} className="btn btn-primary btn-sm">
         {localization.checkOut}
         <img src={Images?.ArrowRight} alt="" />
        </Button>
      : <Button onClick={handleCheckIn} className="btn btn-primary btn-sm">
         {localization.checkIn}
         <img src={Images?.ArrowRight} alt="" />
       </Button>
    }
      
      
    </Fragment>
  );
};

const handleModalHide = (url = '') => {
  setIsModal(false);
  setIsSuccessModal(false);
  if(url !== ''){
      history.push(`${baseUrl}/${url}`);
  }
};

const handleSiteStatus = (val) => {
   if(val) {
    const list = {...inputList};
    list['boom_barrier_present'] = val;
    list['site_status'] = (val === 'Yes') ? 'Taken' : 'Open';
    setInputList(list);
    setIsElementRequired((val === 'Yes') ? true : false);
   }
}

console.log('dd ' + JSON.stringify(inputList));
return (
  <Layout
    title={localization.completeCSmeeting}
    isGoback
    Buttons={headerBtns}
    isLoading={isLoading}
  >
  <div className="container-fluid">
    <CardSection title={localization.completeMeetingNCS}>
            <div className="details-listing">
              <DivLayout
                  heading={'Account Id'}
                  data={ncsData && ncsData?.account_id}
              />
              <DivLayout
                    heading={'Account Name'}
                    data={ncsData && ncsData?.client_name}
              />
              <DivLayout
                  heading={'Assined To'}
                  data={ncsData && ncsData?.name}
              />
              <DivLayout
                  heading={'Account Address'}
                  data={ncsData && ncsData?.address_1}
              />
              <DivLayout
                  heading={'Status'}
                  data={ncsData && ncsData?.status}
              />
              <DivLayout
                  heading={'Created At'}
                  data={ncsData && ncsData?.created_at}
              />
              <DivLayout
                  heading={'Scheduled Against Site Number'}
                  data={ncsData && ncsData?.site_number}
              />
              <DivLayout
                  heading={'Scheduled Against Site Name'}
                  data={ncsData && ncsData?.lead_site_client_name}
              />
              <DivLayout
                  heading={'Scheduled Against Site Address'}
                  data={ncsData && ncsData?.lead_site_address_1}
              />
            </div>
      </CardSection>
      {isCheckInStatus &&
        <>
        <CardSection title={localization.fillDetails}>
        <div class="row">
        {/* <div class="col-md-12 mbk-4">
          <CheckboxFir
              label={localization.checkboxDescriptoion}
              type="checkbox"
              value={``}
              isChecked={inputList?.not_allowed_to_take_information}
              errorMsg={localization.isRequired}
              required
              onChange={(val) => {
                handleInput2Value(val);
              }}
          />
        </div> */}
        <div className="col-md-6 col-sm-12">
            <ConstantInput
              name="account_name"
              label={localization.accountName}
              type="text"
              required={true}
              isStarRequired={true}
              errorMsg={localization.isRequired}
              value={inputList?.account_name}
              handleChange={(val) => {
                setInputList({...inputList, account_name:val});
              }}
              disabled={true}
            />
          </div>
          <div className="col-md-6 col-sm-12">
            <ConstantInput
              name="address_details"
              label={localization.accountAddress}
              type="text"
              required={true}
              isStarRequired={true}
              errorMsg={localization.isRequired}
              value={inputList?.account_address}
              handleChange={(val) => {
                setInputList({...inputList, account_address:val});
              }}
              disabled={true}
            />
          </div>
          <div className="col-md-6 col-sm-12">
            <DatePicker
              name="last_activity"
              label={localization.lastActivityDate}
              type="date"
              handleChange={(val) => {
                setInputList({...inputList, last_activity_date:val});
              }}
              required={true}
              isStarRequired={true}
              errorMsg={localization.isRequired}
              value={inputList?.last_activity_date}
              maxDate={new Date()}
              disabled={true}
            />
          </div>
          <div className="col-md-6 col-sm-12">
            <ConstantInput
              name="no_of_gates"
              label={localization.noOfgates}
              type="number"
              required={true}
              isStarRequired={true}
              errorMsg={localization.isRequired}
              value={inputList?.no_of_gates}
              handleChange={(val) => {
                setInputList({...inputList, no_of_gates:val});
              }}
            />
          </div>
          <div className="col-md-6 col-sm-12">
            <DropDownInput
              name="boom_barrier_present"
              data={[
                {
                  name: "Yes",
                  id: "Yes",
                },
                {
                  name: "No",
                  id: "No",
                }
              ]}
              label={localization.boomBarierPresent}
              required={true}
              isStarRequired={true}
              errorMsg={localization.isRequired}
              getIdValue={(val) => {
                //setInputList({...inputList, boom_barrier_present:val.id});
                handleSiteStatus(val.id);
              }
              }
              value={inputList?.boom_barrier_present}
            />
          </div>
          <div className="col-md-6 col-sm-12">
            <DropDownInput
              name="status"
              data={[
                {
                  name: "Open",
                  id: "Open",
                },
                {
                  name: "Taken",
                  id: "Taken",
                }
              ]}
              label={localization.siteStatus}
              required={true}
              isStarRequired={true}
              errorMsg={localization.isRequired}
              getIdValue={(val) => setInputList({...inputList, site_status:val.id})}
              value={inputList.site_status}
              disabled={true}
            />
          </div>
          <div className="col-md-6 col-sm-12">
            <ConstantInput
              name="competitor_name"
              label={localization.competitorName}
              type="text"
              required={isElementRequired}
              isStarRequired={isElementRequired}
              errorMsg={localization.isRequired}
              value={inputList?.competitor_name}
              handleChange={(val) => {
                setInputList({...inputList, competitor_name:val});
              }}
            />
          </div>
          <div className="col-md-6 col-sm-12">
            <ConstantInput
              name="competitor_solution"
              label={localization.competitorSolution}
              type="text"
              required={isElementRequired}
              isStarRequired={isElementRequired}
              errorMsg={localization.isRequired}
              value={inputList?.competitor_solution}
              handleChange={(val) => {
                setInputList({...inputList, competitor_solution:val});
              }}
            />
          </div>
          <div className="col-md-6 col-sm-12">
            <ConstantInput
              name="existing_problem_faced"
              label={localization.existingProblemFaced}
              type="text"
              required={isElementRequired}
              isStarRequired={isElementRequired}
              errorMsg={localization.isRequired}
              value={inputList?.exisiting_problem_faced}
              handleChange={(val) => {
                setInputList({...inputList, exisiting_problem_faced:val});
              }}
            />
          </div>

          <div class="col-md-12">
          {addItem === 1 ? (
                    <>
                      {inputList.attachments.map((x, i) => {
                        return (
                          <div className="" key={{ i }}>
                            <div className="">
                            {/* <FileUpload
                                id={`addAttachment_`+i}
                                accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.webm,.mkv"
                                documentUploadUrl={documentUploadUrlPublic}
                                documentUrlData={documentUrlDataPublic}
                                onChange={(val) => saveAttachmentDoc(val,i)}
                              >
                                <span className="btn btn-transparent">
                                  {localization.attachment}
                                </span>
                              </FileUpload> */}
                              {x.url !== "" ? (
                                  <>
                                      <img src={`${x.url}`} alt={""} style={{ marginLeft: "" }} width={250} height={250} />
                                      <div className='container mt-4 mb-2'>
                                          <Button
                                              className="btn-sm"
                                              style={{ marginLeft: "0%" }}
                                              onClick={() => {
                                                removeAttachmentDoc("",i);
                                              }}
                                          >
                                              {"Retake"}
                                          </Button>
                                      </div>
                                  </>
                              ) : (
                                  (!x.retake && x.show) && (
                                      <Camera
                                          id={`cam_${i}`}
                                          idealFacingMode={'user'}
                                          idealResolution={{ width: 400, height: 250 }}
                                          onTakePhoto={(dataUri) => {
                                              setIsLoading(true);
                                              saveAttachmentDoc(dataUri,i);
                                              setIsLoading(false);
                                          }}
                                      />
                                  )
                              )}
                              <div className="container mb-2 d-flex">
                                {inputList.attachments.length !== 1 && (
                                  <div className="">
                                    <button
                                      style={{ marginLeft: "0%" }}
                                      onClick={() => handleRemoveClick(i)}
                                      className="mr10 btn btn-sm btn-danger"
                                    >
                                      Remove
                                    </button>
                                  </div>
                                )}
                                {inputList.attachments.length - 1 === i && (
                                  <div className="">
                                    <button
                                      style={{ marginLeft: "0%" }}
                                      className="btn btn-sm btn-primary"
                                      onClick={handleAddClick}
                                    >
                                      Add
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </>
                  ) : addItem === 2 ? (
                    {}
                  ) : null}
              </div>
          </div>  
        </CardSection>
        <CardSection title={localization.checkout}>
        <div class="row">
          <div className="col-sm-12 col-md-12 mb-5 mt-1 float-field">
                  {selfieUrl !== "" ? (
                      <>
                          <div className='container mt-4'>
                          <img src={`${selfieUrl}`} alt={""} style={{ marginLeft: "" }} />
                              <Button
                                  className="btn-sm"
                                  style={{ marginLeft: "46%" }}
                                  onClick={() => {
                                      setRetake(true);
                                      setSelfieUrl("");
                                      setSelfie("");
                                  }}
                              >
                                  {"Retake"}
                              </Button>
                          </div>
                      </>
                  ) : (
                      retake && (
                       //memoizedCamera
                          <Camera
                              idealFacingMode={'user'}
                              idealResolution={{ width: 400, height: 250 }}
                              onTakePhoto={(dataUri) => {
                                  setIsLoading(true);
                                  setSelfie(dataUri);
                                  setRetake(false);
                                  setIsLoading(false);
                              }}
                          />
                      )
                  )}
              </div>
              <div className="col-sm-12 col-md-12 mb-5 mt-1 float-field">
                  <ConstantInput
                    name="remark"
                    label={localization.remark}
                    type="text"
                    required={true}
                    isStarRequired={true}
                    errorMsg={localization.isRequired}
                    value={inputList?.checkout_remark}
                    handleChange={(val) => {
                      setInputList({...inputList, checkout_remark:val});
                    }}
                  />
                </div>
          </div>
        </CardSection>
        </>
      } 
        <ModalPop
            title={localization.conf}
            show={isSuccessModal}
            handleModalHide={()=> handleModalHide('ncs-meetings')}
        >
            <div className="text-center">
                <div className="success">
                    <img src={Images?.tick} alt="" />
                </div>
                <h5>{'Checkout successfully.'}</h5>
            </div>
        </ModalPop>
        <ModalPop
            title={localization.checkIn}
            show={isCheckIn}
            handleModalHide={()=> hideCheckIn()}
        >
            <div className="text-center">
              <div class="row">
              <div className="col-sm-12 col-md-12 mb-2">
                <span>Latitude: {latVal}</span> <span>Longitude: {lngVal}</span>
              </div>
              <div className="col-sm-12 col-md-12 mb-5 mt-1 float-field">
                      {selfieUrlCheckIn !== "" ? (
                          <>
                              <img src={`${selfieUrlCheckIn}`} alt={""} style={{ marginLeft: "" }} />
                              <div className='container mt-4'>
                                  <Button
                                      className="btn-sm"
                                      style={{ marginLeft: "46%" }}
                                      onClick={() => {
                                          setRetakeOne(true);
                                          setSelfieUrlCheckIn("");
                                          setSelfieCheckin("");
                                      }}
                                  >
                                      {"Retake"}
                                  </Button>
                              </div>
                          </>
                      ) : (
                        retakeOne && (
                              <Camera
                                  idealFacingMode={'user'}
                                  idealResolution={{ width: 300, height: 250 }}
                                  onTakePhoto={(dataUri) => {
                                      setIsLoading(true);
                                      setSelfieCheckin(dataUri);
                                      setRetakeOne(false);
                                      setIsLoading(false);
                                  }}
                              />
                          )
                      )}
                  </div>
                  <div className="col-sm-12 col-md-12 mb-5 mt-1 float-field">
                      <ConstantInput
                        name="remark"
                        label={localization.remark}
                        type="text"
                        required={true}
                        isStarRequired={true}
                        errorMsg={localization.isRequired}
                        value={inputList?.checkout_remark}
                        handleChange={(val) => {
                          setCheckinRemark(val);
                        }}
                      />
                    </div>
                    <div className="text-center">
                    <Button onClick={handleSubmitCheckIn} className="btn btn-primary btn-sm">
                      {localization.submit}
                      <img src={Images?.ArrowRight} alt="" />
                    </Button>
                    </div> 
              </div>
            </div>
        </ModalPop>
    </div>
  </Layout>
);
};

export default NcsMeetingComplete;
